import React from 'react';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { PLCCPod } from '@thd-olt-component-react/consumer-card-messaging';
import {
  LayoutManager,
  LayoutGroup,
} from '@thd-olt-component-react/layout-manager';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedPrivateLabelCreditCard({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
}) {
  return function PrivateLabelCreditCard() {
    return (
      <Hydrator
        id="PLCC-php-hydrator"
        className={styles('u-height-100')}
        scrollBuffer={SCROLL_BUFFER}
        delay={HOMEPAGE_DELAY_STANDARD}
        placeholder={PLACEHOLDER}
      >
        <LayoutManager name="buy-area" useContextForProps>
          <LayoutGroup name="consumer-card-messaging">
            <PLCCPod />
          </LayoutGroup>
        </LayoutManager>
      </Hydrator>
    );
  };
}
